module.exports = __webpack_public_path__ + "img/nebraska-empoweredhealing.d90c7fbd.png";